import { Contrato, ContratoPpp, ContratoRescisao, ContratoStorage, ContratoTerceirizado, ContratoTestemunha, Empenho, ImovelOcorrencia, Usuario } from 'eddydata-lib';
import { TipoContrato } from '../../components/types';
import { BaseResourceModel } from '../../models/base-resource.model';
import { Orgao } from '../comum/orgao.model';
import { LicitacaoAudesp } from '../licitacao/licitacao-audesp.model';
import { Licitacao } from '../licitacao/licitacao.model';
import { Modalidade } from '../licitacao/modalidade.model';
import { TipoContratacao } from '../licitacao/tipo-contratacao.model';
import { ContratoAditamento } from './contrato-aditamento.model';
import { ContratoFiscal } from './contrato-fiscal.model';
import { ContratoItem } from './contrato-item.model';
import { ContratoOcorrencia } from './contrato-ocorrencia.model';
import { ContratoPncp } from './contrato-pncp.model';
import { ContratoResponsavel } from './contrato-responsavel.model';
import { Favorecido } from './favorecido.model';
import { Prazo } from './prazo.model';
import { ContratoRemanejo } from './contrato-remanejo.model';

export class ContratoEnvolvidos extends BaseResourceModel {
  constructor(
    public id?: number,
    public contrato?: Contrato,
    public tipo_envolvido?: string,
    public cnpj?: string,
    public codigo_unidade?: string,
    public cadastrado_pncp?: boolean
  ) {
    super();
  }

  static converteJson(json: any): ContratoEnvolvidos {
    return Object.assign(new ContratoEnvolvidos(), json);
  }
}
